"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchProviders = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var PAGE_SIZE = 32;
var PAGE_SIZE_MOBILE = 24;
var useSearchProviders = function () {
    var _a = (0, react_1.useState)(1), page = _a[0], setPage = _a[1];
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var data = (0, swr_hooks_1.useProviders)().data;
    var _b = (0, react_1.useState)(''), searchValue = _b[0], setSearchValue = _b[1];
    var handlePageClick = (0, react_1.useCallback)(function (e) {
        setPage((e.nextSelectedPage !== undefined ? e.nextSelectedPage : e.selected) +
            1);
    }, [setPage]);
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setPage(1);
        setSearchValue(target.value);
    }, []);
    var onSearchClear = (0, react_1.useCallback)(function () {
        setSearchValue('');
    }, []);
    var pageSize = (0, react_1.useMemo)(function () {
        if (Object.keys(breakpoints).length > 0)
            return breakpoints.mobile || breakpoints.tablet
                ? PAGE_SIZE_MOBILE
                : PAGE_SIZE;
        else
            return PAGE_SIZE;
    }, [breakpoints]);
    var dataFilteredBySearch = (0, react_1.useMemo)(function () {
        if (!searchValue || searchValue === '' || !data)
            return data;
        return data.filter(function (item) {
            return item.title.toLowerCase().startsWith(searchValue.toLowerCase());
        });
    }, [searchValue, data]);
    var filteredProviders = (0, react_1.useMemo)(function () {
        var startIndex = (page - 1) * pageSize;
        var endIndex = startIndex + pageSize;
        if (!dataFilteredBySearch || dataFilteredBySearch.length === 0)
            return [];
        return dataFilteredBySearch.slice(startIndex, endIndex);
    }, [dataFilteredBySearch, page, pageSize]);
    return (0, react_1.useMemo)(function () { return ({
        filteredProviders: filteredProviders,
        searchValue: searchValue,
        onSearchChange: onSearchChange,
        onSearchClear: onSearchClear,
        page: page,
        handlePageClick: handlePageClick,
        pageSize: pageSize,
        allProviders: dataFilteredBySearch,
    }); }, [
        filteredProviders,
        searchValue,
        onSearchChange,
        dataFilteredBySearch,
        onSearchClear,
        page,
        handlePageClick,
        pageSize,
    ]);
};
exports.useSearchProviders = useSearchProviders;
